// Projective mapping of a w×h element onto an arbitrary quadrilateral,
// expressed as a CSS matrix3d(). The element must use transform-origin: 0 0.
// Corner order: [topLeft, topRight, bottomLeft, bottomRight], each [x, y].

function adjugate(m) {
  return [
    m[4] * m[8] - m[5] * m[7], m[2] * m[7] - m[1] * m[8], m[1] * m[5] - m[2] * m[4],
    m[5] * m[6] - m[3] * m[8], m[0] * m[8] - m[2] * m[6], m[2] * m[3] - m[0] * m[5],
    m[3] * m[7] - m[4] * m[6], m[1] * m[6] - m[0] * m[7], m[0] * m[4] - m[1] * m[3],
  ];
}

function multiply(a, b) {
  const c = new Array(9);
  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 3; j++) {
      c[3 * i + j] = a[3 * i] * b[j] + a[3 * i + 1] * b[3 + j] + a[3 * i + 2] * b[6 + j];
    }
  }
  return c;
}

function multiplyVector(m, v) {
  return [
    m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
    m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
    m[6] * v[0] + m[7] * v[1] + m[8] * v[2],
  ];
}

// Matrix mapping the projective basis onto the four points.
function basisToPoints([p0, p1, p2, p3]) {
  const m = [p0[0], p1[0], p2[0], p0[1], p1[1], p2[1], 1, 1, 1];
  const v = multiplyVector(adjugate(m), [p3[0], p3[1], 1]);
  return multiply(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]);
}

export function quadToMatrix3d(w, h, quad) {
  const src = basisToPoints([[0, 0], [w, 0], [0, h], [w, h]]);
  const dst = basisToPoints(quad);
  const t = multiply(dst, adjugate(src)).map((x, _, arr) => x / arr[8]);
  return `matrix3d(${t[0]},${t[3]},0,${t[6]},${t[1]},${t[4]},0,${t[7]},0,0,1,0,${t[2]},${t[5]},0,1)`;
}
